interface SectionHeaderProps {
  title: string;
  description?: string;
  className?: string;
}

const SectionHeader = ({
  title,
  description,
  className = "",
}: SectionHeaderProps) => (
  <header className={className}>
    <h2>{title}</h2>
    {description && <p>{description}</p>}
  </header>
);

export default SectionHeader;
